import { useAppContext } from '@/context/AppContext';
import useTranslation from '@/i18n/use-translation';
import { Page } from '@parentsquare/squarekit/components/app/Layout/Page';
import { PageHeader } from '@parentsquare/squarekit/components/app/Layout/PageHeader';
import { Container } from '@parentsquare/squarekit/components/app/Layout/Container';
import { Skeleton } from '@parentsquare/squarekit/components/ui/skeleton';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@parentsquare/squarekit/components/ui/tabs';
import React from 'react';

import { SUMMARY_CARDS_GRID } from './summaryCardsLayout';
import { CHART_CARD_SKELETON_HEIGHT, SUMMARY_CARD_SKELETON_HEIGHT } from './adminReportLayout';
import type { StickersAdminReportAppContext } from './types';

/** Shown while the lazy route chunk loads. */
export function AdminReportViewFallback() {
  const { t } = useTranslation();
  const { showGrowthAreas } = useAppContext<StickersAdminReportAppContext>();

  return (
    <>
      <PageHeader>{t('admin_report.title')}</PageHeader>

      <Page>
        <Container className="tw:mb-0">
          <Tabs defaultValue="overview" version="v1">
            <TabsList className="tw:ml-0 tw:w-full">
              <TabsTrigger value="overview" disabled>
                {t('admin_report.tabs.overview')}
              </TabsTrigger>
              <TabsTrigger value="teachers" disabled>
                {t('admin_report.tabs.teachers')}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="overview" className="tw:px-0 tw:pb-0 tw:pt-(--spacing-16)">
              <div className="tw:flex tw:flex-col tw:gap-(--spacing-16)">
                <div className={SUMMARY_CARDS_GRID}>
                  <Skeleton className={`${SUMMARY_CARD_SKELETON_HEIGHT} tw:min-w-0`} />
                  <Skeleton className={`${SUMMARY_CARD_SKELETON_HEIGHT} tw:min-w-0`} />
                  {showGrowthAreas && (
                    <Skeleton className={`${SUMMARY_CARD_SKELETON_HEIGHT} tw:min-w-0`} />
                  )}
                </div>
                <Skeleton className={`${CHART_CARD_SKELETON_HEIGHT} tw:w-full`} />
                <Skeleton className="tw:h-[320px] tw:w-full" />
              </div>
            </TabsContent>
          </Tabs>
        </Container>
      </Page>
    </>
  );
}
